module.exports = __webpack_public_path__ + "img/Your Decisions.936596ac.png";